import {initializeLoadMoreFormHandler} from "./load-more-form-handler.js";
import {registerOnchangeSubmitHandler} from "./onchange-submit.js";
import installRequestSubmitPolyfill from "../_snowpack/pkg/@koppe/form-request-submit-polyfill.js";
(async () => {
  await installRequestSubmitPolyfill();
  document.querySelectorAll(".ce--list.ce--downloads_list").forEach((e) => {
    initializeLoadMoreFormHandler(e);
    e.querySelectorAll(".download-list__filter-onchange-submit").forEach((filter) => {
      registerOnchangeSubmitHandler(filter);
    });
  });
})();
